import { Form, Input, Button, Flex } from 'antd';
import classesAuth from '../../common/styles/FormStyles.module.scss';
import getInputRules, { inputType } from '../../utils/getInputRules';
import classesProfile from '../../pages/Profile/style.module.scss';

const OTPVerificationForm = ({ form, loading, onSubmit, onBack, t }) => {
    return (
        <Form form={form} onFinish={onSubmit} style={{ width: 'clamp(300px, 85vw, 464px)' }} requiredMark={false}>
            <Form.Item
                className={classesAuth['form-item']}
                label={<span className={classesAuth['form-label']}>{t('profile:form.label.verificationCode')}</span>}
                name="otp"
                rules={getInputRules(t, inputType.OTP, t('form:errors.required'))}
                labelCol={{ span: 24 }}
                style={{ marginBottom: '18px' }}
            >
                <Input.OTP />
            </Form.Item>
            <Flex justify="space-between">
                <Button onClick={onBack} size="large" className={classesProfile.backButton}>
                    {t('profile:backButton')}
                </Button>
                <Button
                    htmlType="submit"
                    type="primary"
                    size="large"
                    className={classesProfile.submitForm}
                    loading={loading}
                >
                    {t('profile:verifyButton')}
                </Button>
            </Flex>
        </Form>
    );
};

export default OTPVerificationForm;
